import Gift3 from "./assets/image/SelectorImage/gift_3.png";
import Gift2 from "./assets/image/SelectorImage/gift_2.png";
import Gift1 from "./assets/image/SelectorImage/gift_1.png";

export const imageShowData = [
  Gift1, // Apple
  Gift2, // Mango
  Gift3, // Watermelon
];
